import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Get, Put } from '@app/utils/httpProvider';
import { useQuery, useMutation } from 'react-query';
import { CHUYENMON_API } from '@app/utils/apiUrl.js';
import { messageToast, status200, status201 } from '@app/utils/define';

const schema = yup.object().shape({
    tenChuyenMon: yup.string().required('Tên chuyên môn không được để trống')
});

const ChuyenMonEdit = () => {
    const history = useHistory();
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const itemId = paramUrl.get('id');

    const itemEdit = useQuery([itemId], () => Get(CHUYENMON_API.GET_ITEM, itemId), {
        enabled: !!itemId
    });
    const editFunc = useMutation((value) => Put(CHUYENMON_API.UPDATE_ITEM, itemId, value));

    const handleEdit = async (values) => {
        editFunc.mutate(values, {
            onSuccess: (res) => {
                if (res && (res.status === status200 || res.status === status201)) {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    history.goBack();
                } else {
                    toast.error(messageToast.messageToastUpdateError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại!');
            }
        });
    };

    if (itemEdit.isLoading) {
        return <div>Đang tải...</div>;
    }

    if (itemEdit.isError) {
        return <div>Có lỗi xảy ra: {itemEdit.error?.message}</div>;
    }

    if (!itemEdit.data) {
        return <div>Không tìm thấy chuyên môn.</div>;
    }

    return (
        <Card>
            <Card.Header as="h5">Sửa chuyên môn</Card.Header>
            <Card.Body>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(values) => handleEdit(values)}
                    initialValues={{
                        tenChuyenMon:
                            itemEdit.data.tenChuyenMon || itemEdit.data.TenChuyenMon || ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên chuyên môn
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập tên chuyên môn"
                                        type="text"
                                        name="tenChuyenMon"
                                        value={values.tenChuyenMon}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tenChuyenMon}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tenChuyenMon}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup>
                                        <Button type="submit" theme="primary" disabled={editFunc.isLoading}>
                                            Lưu
                                        </Button>
                                        <Button
                                            type="button"
                                            theme="secondary"
                                            onClick={() => history.goBack()}
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default ChuyenMonEdit;
